import eSystemControllerTypes from '../eControllerTypes';

export default {
  ERHCT_SPINNER: `${eSystemControllerTypes.ECT_ROUNDS_HISTORY}__spinner`,
  ERHCT_ROUNDS_LIST: `${eSystemControllerTypes.ECT_ROUNDS_HISTORY}__rounds_list`,
  ERHCT_ROUND_RESULT: `${eSystemControllerTypes.ECT_ROUNDS_HISTORY}__round_result`,
}
